import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-5" }
const _hoisted_2 = { class: "border border-gray-300 rounded-md p-4" }
const _hoisted_3 = { class: "flex flex-col md:flex-row gap-x-4" }
const _hoisted_4 = { class: "flex justify-end" }
const _hoisted_5 = { class: "border border-gray-300 rounded-md p-4" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { class: "flex justify-end mt-2" }
const _hoisted_11 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CompanySelector = _resolveComponent("CompanySelector")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_container, {
      style: {"height":"calc(100vh - 80px)"},
      class: "bg-white"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, { style: {"padding":"0px","height":"auto"} }, {
          default: _withCtx(() => [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "h-12 p-4 shadow-md" }, "システム設定 > 安全責任者管理", -1)),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_form, {
                  model: _ctx.searchForm,
                  "label-width": "auto"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_el_form_item, {
                        label: "契約会社名",
                        class: "md:w-80"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CompanySelector, {
                            modelValue: _ctx.searchForm.company_code,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.company_code) = $event)),
                            isSearch: true,
                            disabled: _ctx.loginUserRole !== _ctx.ROLES.SYSTEM
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        class: "w-24",
                        type: "primary",
                        onClick: _ctx.handleSearchButton
                      }, {
                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                          _createTextVNode("検索")
                        ])),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_button, {
                    class: "w-24",
                    type: "primary",
                    onClick: _ctx.handleAddButton
                  }, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createTextVNode("新規登録")
                    ])),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_main, { style: {"padding-block":"0px"} }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_table, {
                data: _ctx.mTableData,
                height: 'calc(100vh - 380px)'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "編集",
                    width: "60",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      (_ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && (scope.row.user_role === _ctx.ROLES.GENERAL || _ctx.loginUserCode === scope.row.user_code)))
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            type: "primary",
                            link: "",
                            onClick: ($event: any) => (_ctx.handleEditButton(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Edit)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "user_code",
                    label: "コード",
                    width: "160"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "user_name",
                    label: "ユーザー名",
                    "min-width": "200"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "所属契約会社 - 部署",
                    "min-width": "360"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", null, _toDisplayString(scope.row.company_info.company_name) + " - " + _toDisplayString(scope.row.company_info.department_name), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "telephone",
                    label: "電話番号",
                    width: "160"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "ユーザー権限",
                    width: "160",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      (scope.row.user_role === _ctx.ROLES.SYSTEM)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "システム管理者"))
                        : (scope.row.user_role === _ctx.ROLES.ADMIN)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "契約会社管理者"))
                          : (scope.row.user_role === _ctx.ROLES.GENERAL)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, "現場責任者"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_9, "不明"))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "is_active",
                    label: "有効",
                    width: "80",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_switch, {
                        modelValue: scope.row.is_active,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.is_active) = $event),
                        onChange: ($event: any) => (_ctx.handleSwitchChange(scope.row)),
                        disabled: (_ctx.loginUserRole === _ctx.ROLES.SYSTEM && _ctx.loginUserCode === scope.row.user_code) || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && scope.row.user_role !== _ctx.ROLES.GENERAL)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "削除",
                    width: "60",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      ((_ctx.loginUserRole === _ctx.ROLES.SYSTEM && scope.row.user_code !== _ctx.loginUserCode) || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && scope.row.user_role === _ctx.ROLES.GENERAL))
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            type: "danger",
                            link: "",
                            onClick: ($event: any) => (_ctx.handleDeleteButton(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Delete)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_pagination, {
                "current-page": _ctx.mCurrentPage,
                "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mCurrentPage) = $event)),
                "page-size": _ctx.mPageSize,
                "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mPageSize) = $event)),
                "page-sizes": [10, 20, 50],
                layout: "total, sizes, prev, pager, next, jumper",
                total: _ctx.mTotalRecords,
                onSizeChange: _ctx.handleSizeChange,
                onCurrentChange: _ctx.handleCurrentChange
              }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
            ])
          ]),
          _: 1
        })), [
          [_directive_loading, _ctx.loading]
        ]),
        _createVNode(_component_el_footer, { style: {"height":"20px"} })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dialogFormVisible) = $event)),
      title: _ctx.form.add_update === 'add' ? 'ユーザー新規登録' : 'ユーザー編集',
      width: "600px",
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_button, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.dialogFormVisible = false))
          }, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [
              _createTextVNode("キャンセル")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleAddUpdateSubmit(_ctx.formRef)))
          }, {
            default: _withCtx(() => _cache[16] || (_cache[16] = [
              _createTextVNode("確認")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          rules: _ctx.rules,
          ref: "formRef",
          "label-width": "150px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "ユーザーコード",
              prop: "user_code"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.user_code,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.user_code) = $event)),
                  disabled: _ctx.form.add_update === 'update',
                  placeholder: "ユーザーコードを入力"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "ユーザー名",
              prop: "user_name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.user_name,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.user_name) = $event)),
                  placeholder: "ユーザー名を入力"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "所属契約会社",
              prop: "company_code"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CompanySelector, {
                  modelValue: _ctx.form.company_code,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.company_code) = $event)),
                  disabled: _ctx.loginUserRole !== _ctx.ROLES.SYSTEM
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "パスワード",
              prop: "password"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.password,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.password) = $event)),
                  placeholder: "パスワードを入力",
                  type: _ctx.form.add_update === 'update' ? 'password': ''
                }, null, 8, ["modelValue", "type"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "電話番号",
              prop: "telephone"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.telephone,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.telephone) = $event)),
                  placeholder: "電話番号を入力"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "ユーザー権限",
              prop: "user_role"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.user_role,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.user_role) = $event)),
                  placeholder: "権限を選択してください",
                  disabled: _ctx.loginUserRole !== _ctx.ROLES.SYSTEM
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "システム管理者",
                      value: _ctx.ROLES.SYSTEM
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      label: "契約会社管理者",
                      value: _ctx.ROLES.ADMIN
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      label: "現場責任者",
                      value: _ctx.ROLES.GENERAL
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}